import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { TriangleAlert } from 'lucide-react';

import { Button } from '@/components/ui/buttons';
import { EmptyState } from '@/components/ui/feedback';
import { ICON_SIZE } from '@/components/ui/iconSize';
import { DEFAULT_ROUTE } from '@/config/routes';

/** Shows a failed page in the content area, with a reload and a way back. */
export function RouteErrorPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <EmptyState
      icon={<TriangleAlert size={ICON_SIZE.xxl} />}
      title={t('routeError.title')}
      description={t('routeError.description')}
      plain
      className="min-h-error-page"
      action={
        <div className="flex gap-2">
          <Button variant="secondary" onClick={() => navigate(DEFAULT_ROUTE)}>
            {t('notFound.action')}
          </Button>
          <Button onClick={() => window.location.reload()}>{t('routeError.reload')}</Button>
        </div>
      }
    />
  );
}
